import { getFormValues } from 'redux-form';
import { createSelector } from 'reselect';
import { getProp } from '../../utilities';
import { MAX_PASSENGERS } from '../App/constants';
import { ticketTypeSelector } from '../App/selectors';
import {
  firstWayConnectionIdSelector,
  secondWayConnectionIdSelector,
} from '../Reservation/selectors';
import { FORM_NAME } from './form';
import { serializeConnectionInfo } from './reducer';

const ticketsDomain = state => state.tickets;

export const formValuesSelector = state => getFormValues(FORM_NAME)(state);

export const ticketsByConnectionInfoSelector = createSelector(
  ticketsDomain,
  substate => substate.byConnectionInfo,
);

export const ticketsSelector = createSelector(
  ticketTypeSelector,
  firstWayConnectionIdSelector,
  secondWayConnectionIdSelector,
  ticketsByConnectionInfoSelector,
  (ticketType, connectionId1, connectionId2, byConnectionInfo) => {
    const key = serializeConnectionInfo(
      ticketType,
      connectionId1,
      connectionId2,
    );
    return key in byConnectionInfo ? byConnectionInfo[key].tickets : [];
  },
);

export const ticketsIsFetchingSelector = createSelector(
  ticketTypeSelector,
  firstWayConnectionIdSelector,
  secondWayConnectionIdSelector,
  ticketsByConnectionInfoSelector,
  (ticketType, connectionId1, connectionId2, byConnectionInfo) => {
    const key = serializeConnectionInfo(
      ticketType,
      connectionId1,
      connectionId2,
    );
    return key in byConnectionInfo ? byConnectionInfo[key].isFetching : false;
  },
);

export const tarrifByTicketIdxSelector = createSelector(
  ticketsSelector,
  tickets => {
    return tickets.map(ticket => {
      return ticket.tarrif.reduce((acc, tarrif) => {
        return { ...acc, [tarrif.id_tarrif]: tarrif };
      }, {});
    });
  },
);

/**
 * V podstate chceme dostat pole poli [[]].
 * Prva uroven su pasazieri, druha uroven su ceny za kazdy jeden listok.
 * Cize ak mam 2 pasazierov a 3 listky tak [[100, null, null],[null, 150, 50]].
 * null znamena, ze pre konkretneho pasaziera a pre konkretny listok nebola vybrana tarifa.
 */
export const ticketPricesForEachPassengerSelector = createSelector(
  formValuesSelector,
  ticketsSelector,
  tarrifByTicketIdxSelector,
  (formValues, tickets, tarrifByTicketIdx) => {
    return getProp(formValues, ['passengers'], []).map(passenger => {
      return tickets.map((ticket, ticketIdx) => {
        const selectedTarrifId = getProp(
          passenger,
          ['ticket', ticketIdx],
          null,
        );
        const selectedTarrifPrice = Number.parseFloat(
          getProp(
            tarrifByTicketIdx,
            [ticketIdx, selectedTarrifId, 'price_total'],
            null,
          ),
        );
        if (!selectedTarrifPrice || Number.isNaN(selectedTarrifPrice)) {
          return null;
        }
        return selectedTarrifPrice;
      });
    });
  },
);

export const totalPriceForEachPassengerSelector = createSelector(
  ticketPricesForEachPassengerSelector,
  ticketPrices => {
    return ticketPrices.map(passengerTickets => {
      return passengerTickets.reduce((acc, price) => {
        if (price === null) {
          return acc + 0;
        }
        return acc + price;
      }, 0);
    });
  },
);

export const totalPriceSelector = createSelector(
  totalPriceForEachPassengerSelector,
  passengerPrices => {
    return passengerPrices.reduce((acc, price) => {
      return acc + price;
    }, 0);
  },
);

export const remainingPassengerCountSelector = createSelector(
  formValuesSelector,
  passengerFormValues =>
    MAX_PASSENGERS - getProp(passengerFormValues, ['passengers'], []).length,
);

export const passengerCountSelector = createSelector(
  formValuesSelector,
  passengerFormValues =>
    getProp(passengerFormValues, ['passengers'], []).length,
);



// WEBPACK FOOTER //
// ./src/containers/Passengers/selectors.js